module.exports = __webpack_public_path__ + "img/yyz1.949e1b30.png";